import SectionLabel from "../../../components/SectionLabel";

export default function Overview({ base }) {
    return (
        <section className="section-pad bg-[#0B0B0C] overflow-hidden">
            <div className="shell grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
                <div className="lg:col-span-7">
                    <SectionLabel number="—" label="Brief" />
                    <p className="mt-8 text-[#F3EFE7] text-lg md:text-[20px] leading-[1.75]">
                        {base.intro}
                    </p>
                </div>
                <aside className="lg:col-span-5">
                    <div className="border-t border-[rgba(201,168,106,0.25)] pt-10 lg:mt-1 grid grid-cols-2 gap-x-10 gap-y-8">
                        <div>
                            <span className="eyebrow">Location</span>
                            <p className="mt-3 text-[#F3EFE7]">
                                {base.location}
                            </p>
                        </div>
                        <div>
                            <span className="eyebrow">Year</span>
                            <p className="mt-3 text-[#F3EFE7]">{base.year}</p>
                        </div>
                        <div className="col-span-2">
                            <span className="eyebrow">Typology</span>
                            <p className="mt-3 text-[#F3EFE7] leading-[1.7]">
                                {base.typology}
                            </p>
                        </div>
                        <div className="col-span-2">
                            <span className="eyebrow">Category</span>
                            <p className="mt-3 text-[#F3EFE7] leading-[1.7] capitalize">
                                {base.category}
                            </p>
                        </div>
                    </div>
                </aside>
            </div>
        </section>
    );
}
